import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {MissionBadgeProps} from '../../../features/Coins/MissionBadge/MissionBadge';
import {MissionType} from '../utils/missionType';
import {useGetActiveMissions} from '../utils/useGetActiveMissions';
import {MissionBadgeView} from './MissionBadgeView';

export const MissionBadge: React.FC<
  Omit<MissionBadgeProps, 'reward'> & {
    missionType: MissionType;
  }
> = ({className, small, showCoinsLabel, missionType}) => {
  return (
    <DataFetcher
      request={useGetActiveMissions()}
      Error={null}
      View={MissionBadgeView}
      Loading={() => null}
      viewProps={{className, small, missionType, showCoinsLabel}}
    />
  );
};
